const initialState = {
  title: null,
  left: null,
  right: null
}
const header = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_HEADER':
      return {
        title: action.payload.title,
        left: action.payload.left,
        right: action.payload.right,
      }

    default:
      return state
  }
}
export default header



// WEBPACK FOOTER //
// ./src/reducers/header.js